import { useParams } from "react-router-dom";
import packages from "../../data/packages";
import PricingSection from "../Section/PricingSection";
import Section from "../Section";
import axios from "axios";
import { useState, useEffect } from "react";
import { FaFlask, FaVial, FaHeartbeat, FaDna } from "react-icons/fa";
import { FaChevronDown } from "react-icons/fa";
import { API_URL, APP_URL } from "../../Config/environment";
import { Link } from "react-router-dom";

function PackageDetail() {
    const [openTest, setOpenTest] = useState(null);
    const [loading, setLoading] = useState(false);
    const [filteredPackage, setFilteredPackage] = useState(null);
    const toggleSubtests = (index) => {
        setOpenTest(openTest === index ? null : index);
    };
    const { id } = useParams();
    
    const getHealthPackage = async (id) => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${API_URL}/health-package/home-page/${id}`
            );
            if (response?.data?.statusCode === 200) {
                const filteredPackage = response.data.data?.package;
                setFilteredPackage(filteredPackage);
            } else {
                console.warn("Unexpected API response:", response.data);
            }
        } catch (error) {
            console.error("Error fetching health package:", error);
        } finally {
            setLoading(false);
        }
    };
    
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        if(id){
            getHealthPackage(id);
        }
    }, [id]);

    // console.log(filteredPackage)
    
    if (!filteredPackage) {
        return <h2>Package not found!</h2>;
    }
    return (
        <Section
            topMd={150}
            topLg={120}
            topXl={100}
            bottomMd={180}
            bottomLg={140}
            bottomXl={110}
        >
            <div className="package-detail">
                {/* Hero Banner */}
                <header className="hero-banner">
                    <div className="hero-content">
                        <h1 className="">{filteredPackage.name}</h1>
                        <p className="discount">
                            Save <span>{filteredPackage.discount}</span> Today!
                        </p>
                    </div>
                </header>

                {/* Floating Package Card */}
                <div className="package-card">
                    <h2>₹{filteredPackage.price}</h2>
                    <p>Includes {filteredPackage.testCounts} + Tests</p>
                    <a
                        href={`${APP_URL}/login?packageId=${id}`}
                        className="book-btn"
                    >
                        Book Now
                    </a>
                </div>

                {/* Tabs Section */}
                <div className="tabs">
                    <button className="tab active">Overview</button>
                    <button className="tab">Tests</button>
                    <button className="tab">Sample</button>
                </div>

                {/* Overview */}
                <section className="tab-content overview">
                    <div className="info-cards">
                        <div className="info-card">
                            <i className="fas fa-vials"></i>
                            <h4>{filteredPackage.testCounts} + </h4>
                            <p>Tests Included</p>
                        </div>
                        <div className="info-card">
                            <i className="fas fa-clock"></i>
                            <h4>{filteredPackage.duration || "N/A"}</h4>
                            <p>Reports Time</p>
                        </div>
                        <div className="info-card">
                            <i className="fas fa-flask"></i>
                            {filteredPackage.testSamples.map((item) => (
                                <h4
                                    key={item}
                                    className=" sample-item"
                                    // style={{display:"flex", alignItems:"center", justifyItems: "center", flexDirection:"row"}}
                                >
                                    {item}
                                </h4>
                            ))}

                            <p>Sample Collection</p>
                        </div>
                    </div>
                </section>

                {/* Tests Section */}
                <section className="tab-content tests">
                    <h3>🔬 Tests Included</h3>
                    <div className="test-list">
                        {filteredPackage.testDetails.map((test, index) => (
                            <div key={index} className="test-card">
                                <div
                                    className="test-header"
                                    onClick={() => toggleSubtests(index)}
                                >
                                    <span className="test-name">
                                        {test.name}
                                    </span>

                                    {test.subTests && (
                                        <i
                                            className={`fas fa-chevron-${
                                                openTest === index
                                                    ? "up"
                                                    : "down"
                                            } toggle-icon`}
                                        ></i>
                                    )}
                                </div>

                                {test.subTests && (
                                    <div
                                        className={`subtest-panel ${
                                            openTest === index ? "open" : ""
                                        }`}
                                    >
                                        <ul className="subtest-list">
                                            {test.subTests.map((sub, i) => (
                                                <li
                                                    key={i}
                                                    className="subtest-item"
                                                >
                                                    {sub}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </section>
            </div>
        </Section>
    );
}

export default PackageDetail;
